import { useState, useCallback } from 'react';
import { useToggle } from '@shopify/react-hooks';

function usePopover() {
  const [popoverKey, setPopoverKey] = useState(0);
  const increment = useCallback(() => setPopoverKey(key => key + 1), []);
  const {
    value: globalPopoverVisibility,
    setTrue: showPopovers,
    setFalse: hidePopovers,
    toggle: togglePopoverVisibility
  } = useToggle(true);
  return {
    globalPopoverVisibility,
    popoverKey,
    rerenderPopovers: increment,
    showPopovers,
    hidePopovers,
    togglePopoverVisibility
  };
}

export { usePopover };
